export const date = {
    labels: {
        second: "Second",
        seconds: "Seconds",
        minute: "Minute",
        minutes: "Minutes",
        hour: "Hour",
        hours: "Hours",
        day: "Day",
        days: "Days",
        week: "Week",
        month: "Month",
        months: "Months",
    },
};